const mutations = {
    SET_LANDINGS(state, {languages, landings, teams, offers}) {
        state.languages = languages
        state.teamsList = teams

        state.landings = landings.map(landing => {
            const offer = offers.find(offer => offer.id === landing.offer_id)
            const language = languages.find(language => language.iso_2 === landing.language.toUpperCase())

            landing.active_name = landing.is_active ? 'On' : 'Off'
            landing.offer_name = offer ? offer.name : ''
            landing.full_language = language ? `[${language.iso_2}] ${language.language}` : ''

            return landing
        })
    },

    SET_COMMON_LANDINGS(state, data) {
        state.landings = data
    }
}

export default mutations
